// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"62cca4dd","114":"c5e30478"}[chunkId] + ".chunk.js";
};